
export default {
  props: {
    myclass: {
      type: String,
      default: ""
    }
  }
};
